// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"470b6bfb","408":"766f52f0","488":"96eb2f0f","806":"e40dd567"}[chunkId] + ".chunk.js";
};